"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const button_1 = require("../button");
const button_2 = require("@atlaskit/button");
const styled_components_1 = __importDefault(require("styled-components"));
const ButtonGroupDiv = styled_components_1.default.div `
  display: flex;
  justify-content: center;
  padding-bottom: 10px;
`;
exports.Presets = ({ presets, handleDatesChange }) => (React.createElement(ButtonGroupDiv, null,
    React.createElement(button_2.ButtonGroup, null, presets.map(({ text, start, end }) => (React.createElement(button_1.Button, { shouldFitContainer: true, key: text, onClick: () => handleDatesChange({ startDate: start, endDate: end }) }, text))))));
